(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["craftmag-category-gallery"] && !Shopify.designMode) return;
  try {
    
import('@theme/component').then(({ Component }) => {
  if (customElements.get('craftmag-product-carousel')) return;
  class CraftmagProductCarousel extends Component {
    connectedCallback() { super.connectedCallback(); this.initialize(); }
    updatedCallback() { super.updatedCallback(); this.initialize(); }
    disconnectedCallback() { super.disconnectedCallback(); this.cleanup(); }
    cleanup() { clearInterval(this.timer); clearTimeout(this.settle); this.abort?.abort(); }
    initialize() {
      this.cleanup();
      this.track = this.querySelector('.cm-gallery__grid');
      this.play = this.querySelector('[data-play]');
      if (!this.track || !this.play) return;
      this.track.querySelectorAll('[data-loop-copy]').forEach(card => card.remove());
      this.cards = Array.from(this.track.children);
      // Five extra cards fill the desktop viewport across the wrap point.
      if (this.cards.length > 5) this.cards.slice(0, 5).forEach(card => {
        const copy = card.cloneNode(true);
        copy.dataset.loopCopy = '';
        copy.setAttribute('aria-hidden', 'true');
        copy.tabIndex = -1;
        copy.querySelectorAll('img').forEach(image => image.loading = 'lazy');
        this.track.append(copy);
      });
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.paused ?? this.reduced.matches;
      this.hovered = false;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.querySelector('[data-next]')?.addEventListener('click', () => { this.move(); this.restart(); }, options);
      this.play.addEventListener('click', () => { this.paused = !this.paused; this.updateButton(); this.restart(); }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; }, options);
      this.track.addEventListener('pointerdown', () => { this.paused = true; this.updateButton(); }, options);
      this.reduced.addEventListener('change', () => {
        if (this.reduced.matches) { this.paused = true; this.updateButton(); }
      }, options);
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.settle);
        this.settle = setTimeout(() => this.normalize(), 180);
      }, options);
      this.updateButton();
      this.restart();
    }
    updateButton() {
      this.play.textContent = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
      this.play.setAttribute('aria-label', this.paused ? this.dataset.playAria : this.dataset.pauseAria);
    }
    restart() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (!this.paused && !this.hovered && !document.hidden && !this.contains(document.activeElement)) this.move();
      }, 2000);
    }
    normalize() {
      const copy = this.track.querySelector('[data-loop-copy]');
      if (!copy || !this.cards.length) return;
      const cycle = copy.getBoundingClientRect().left - this.cards[0].getBoundingClientRect().left;
      if (cycle > 0 && this.track.scrollLeft >= cycle - 2) {
        this.track.scrollTo({ left: Math.max(0, this.track.scrollLeft - cycle), behavior: 'instant' });
      }
    }
    move() {
      if (!this.cards.length) return;
      this.normalize();
      const step = this.cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
      const next = this.track.scrollLeft + step;
      const left = this.track.querySelector('[data-loop-copy]') || next <= this.track.scrollWidth - this.track.clientWidth + 2 ? next : 0;
      this.track.scrollTo({ left, behavior: this.reduced.matches ? 'instant' : 'smooth' });
    }
  }
  customElements.define('craftmag-product-carousel', CraftmagProductCarousel);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["craftmag-daily-products"] && !Shopify.designMode) return;
  try {
    
// London calendar days keep the selection consistent through UK daylight saving changes.
function craftmagLondonDay(date) {
  const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(date);
  const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
  return Math.floor(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day)) / 86400000);
}
function craftmagSeasonalOrder(cards, day) {
  const rotate = list => {
    const start = list.length ? day % list.length : 0;
    return list.slice(start).concat(list.slice(0, start));
  };
  const halloween = rotate(cards.filter(card => card.dataset.halloween === 'true'));
  const christmas = rotate(cards.filter(card => card.dataset.halloween !== 'true' && card.dataset.christmas === 'true'));
  const ordered = [];
  for (let index = 0; index < Math.max(halloween.length, christmas.length); index++) {
    if (halloween[index]) ordered.push(halloween[index]);
    if (christmas[index]) ordered.push(christmas[index]);
  }
  return ordered;
}
import('@theme/component').then(({ Component }) => {
  if (customElements.get('craftmag-daily-products')) return;
  class CraftmagDailyProducts extends Component {
    connectedCallback() { super.connectedCallback(); this.initialize(); }
    updatedCallback() { super.updatedCallback(); this.initialize(); }
    disconnectedCallback() { super.disconnectedCallback(); this.cleanup(); }
    cleanup() { clearInterval(this.timer); this.abort?.abort(); }
    initialize() {
      this.cleanup();
      this.cards = Array.from(this.querySelectorAll('.resource-list__item'));
      delete this.dataset.dailyDate;
      this.refresh();
      this.abort = new AbortController();
      document.addEventListener('visibilitychange', () => this.refresh(), { signal: this.abort.signal });
      this.timer = setInterval(() => this.refresh(), 60000);
    }
    refresh() {
      const day = craftmagLondonDay(new Date());
      if (this.dataset.dailyDate === String(day)) return;
      const count = Math.min(Number(this.dataset.craftmagDaily) || 8, this.cards.length);
      const ordered = craftmagSeasonalOrder(this.cards, day);
      ordered.forEach((card, rank) => { card.hidden = rank >= count; card.style.order = String(rank); });
      this.dataset.dailyDate = String(day);
      this.dataset.dailyReady = 'true';
    }
  }
  customElements.define('craftmag-daily-products', CraftmagDailyProducts);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
